import { render, staticRenderFns } from "./dealer-pay-manage.vue?vue&type=template&id=36a33627&scoped=true&"
import script from "./dealer-pay-manage.vue?vue&type=script&lang=js&"
export * from "./dealer-pay-manage.vue?vue&type=script&lang=js&"
import style0 from "./dealer-pay-manage.vue?vue&type=style&index=0&id=36a33627&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a33627",
  null
  
)

export default component.exports